module.exports = __webpack_public_path__ + "static/media/banner-bond.70f0de20.png";